import { NEUTRAL_COLOURS } from 'constants/colors'

export const STATUS_TAG_COLORS = {
  ATTENDED: '#BBEABB',
  CANCELLED: '#FFB9B9',
  NOSHOW: '#FFD88E',
  PAST: NEUTRAL_COLOURS.GRAY_SECONDARY,
  UPCOMING: '#99CFE9',
}
